import { createContext, Dispatch } from "react";

type initialStateType = {
  _id: string;
  createModalTrainingPlan: boolean;
  deleteModalTrainingPlan: boolean;
  updateModalTrainingPlan: boolean;
  createModalUserTP: boolean;
};

type ModalPartial = {
  state: initialStateType;
  dispatch: Dispatch<any>;
};

export const initialState = {
  _id: "",
  createModalTrainingPlan: false,
  deleteModalTrainingPlan: false,
  updateModalTrainingPlan: false,
  createModalUserTP: false,
};
export enum Types {
  CREATE_TRAININGPLAN = "CREATE_TRAININGPLAN",
  DELETE_TRAININGPLAN = "CREATE_TRAININGPLAN ",
  UPDATE_TRAININGPLAN = "UPDATE_TRAININGPLAN",
  CLEAR_TRAININGPLAN = "CLEAR_TRAININPLAN",
  CREATE_USER_TP = "CREATE_USER_TP",
  CLEAR_USER_TP = "CLEAR_USER_TP",
}
const ModalInitialState = {
  state: initialState,
  dispatch: () => null,
};

const TrainingPlansContext = createContext<ModalPartial>(ModalInitialState);

export default TrainingPlansContext;
